import React from "react"
import ArticleListItem from '../components/articleListItem'
import SEO from '../components/SEO'
import * as PropTypes from "prop-types"

const propTypes = {
  data: PropTypes.object.isRequired,
}

class TagTemplate extends React.Component {
  render() {
    const tag = this.props.data.contentfulTag;
    const {
      name,
      slug,
      article
    } = tag;

    const pageSEO = {
      title: `Articole protectia muncii - ${name}`,
      description: `${name} - Informatii utile referitoare la servicii de protectia muncii necesare pentru firma ta`,
      path: `/articole/etichete/${slug}/`
    };

    return (
      <div className="o-page__content o-page__content--center">
        <SEO pageSEO={pageSEO} />
        <div className="o-container u-pv-20 u-pv-30@tablet u-text-center@tablet">
          <h1>Articole - {name}</h1>
        </div>


        <div className="o-container o-container--text">
          {article && article.map((article, i) => <ArticleListItem node={article} key={i} />)}
        </div>


      </div>
    )
  }
}

TagTemplate.propTypes = propTypes

export default TagTemplate

export const pageQuery = graphql`
  query tagQuery($slug: String) {
    contentfulTag(
      slug: { eq: $slug }
    ) {
      slug
      name
      article {
        id
        slug
        title
        excerpt
        date
        tags {
          slug
          name
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/tag.js